import { MessageToWidget } from "../store/types/messagesToWidget";

export default function usePostMessageToWidget(message: MessageToWidget) {
    var parent =  window.parent;
    if(parent) {
        parent.postMessage(message, "*");
    }
}